const toFahrenheit = (c) => (c * 9) / 5 + 32;

const CurrentWeather = ({ data, unit, setUnit }) => {
  if (!data) return null;

  const date = new Date();

  return (
    <div className="current-weather">
      <div className="left">
        <h2>{data.city}</h2>
        <p className="date">
          {date.toLocaleDateString(undefined, {
            weekday: "long",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </p>

        <p className="description">{data.condition?.description}</p>

        <img src={`${data.condition?.icon_url}`} alt="icon" />

        <div className="temperature-row">
          <div className="temperature">
            <span className="temp-value">
              {data.temperature?.current
                ? Math.round(
                    unit === "metric"
                      ? data.temperature.current
                      : toFahrenheit(data.temperature.current),
                  )
                : "--"}
            </span>
          </div>

          <div className="temp-toggle-inline">
            <button
              onClick={() => setUnit("metric")}
              className={unit === "metric" ? "active" : ""}
            >
              °C
            </button>
            <span>/</span>
            <button
              onClick={() => setUnit("imperial")}
              className={unit === "imperial" ? "active" : ""}
            >
              °F
            </button>
          </div>
        </div>
      </div>

      <div className="right">
        <p>Humidity: {data.temperature?.humidity ?? "--"}%</p>
        <p>Wind: {data.wind.speed} km/h</p>
      </div>
    </div>
  );
};

export default CurrentWeather;
